import Schema from "validate";

const propertyDataSchema = new Schema({
	name: { required: true, type: String, length: { min: 5, max: 120 } },
	address: { required: true, type: String, length: { min: 6, max: 150 } },
	district_id: { required: true, type: Number },
	area: { required: false, type: String, length: { min: 0, max: 30 } },
	post_code: { required: false, type: String, length: { min: 0, max: 10 } },
	property_type_id: { required: false, type: Number },
	price: { type: Number, size: { min: 200 } },
	price_low: { required: false, type: Number, size: { min: 200 } },
	price_high: { required: false, type: Number, size: { min: 200 } },
	description: { required: false, type: String, length: { min: 0, max: 1600 } },

	email: {
		required: false,
		type: String,
		length: { max: 100 },
		// match: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
		// message: {
		// 	match: (path) => `${path} format should be correct`,
		// },
	},
	phone: {
		required: true,
		type: Array,
		each: {
			type: String,
			match: /^\+?[0-9]{5,15}$/i,
			length: { min: 4, max: 15 },
			message: { match: (path) => `${path} can only contain numeric numbers` },
		},
		size: { min: 1 },
	},
	website: { required: false, type: String, length: { min: 0, max: 250 } },

	// socials: {
	// 	required: false,
	// 	type: Array,
	// 	size: { min: 0 },
	// 	each: {
	// 		name: { required: false, type: String, length: { min: 0, max: 30 } },
	// 		link: { required: false, type: String, length: { min: 0, max: 200 } },
	// 	},
	// },
	external_links: {
		type: Array,
		each: {
			name: { type: String },
			link: { type: String },
		},
	},

	// room_config: {
	// 	required: false,
	// 	type: Array,
	// 	each: {
	// 		name: { required: true, type: String, length: { min: 3 } },
	// 		adults: { required: true, type: Number, size: { min: 1 } },
	// 	},
	// },

	// itins: {
	// 	check_in: { type: String },
	// 	check_out: { type: String },
	// },

	// payment_info: {
	// 	type: Array,
	// 	each: { name: { required: true }, method: { required: true } },
	// },

	video_link: { required: false, type: String, length: { min: 0, max: 250 } },
	map_link: { required: false, type: String, length: { min: 0, max: 500 } },
	categories: { required: false, type: Array, each: { required: false }, size: { min: 0, max: 5 } },

	owner_id: { required: false, type: Number },

	price_type: { required: false, type: String, length: { min: 0 } },
});

export const verifyPropertyData = (data) => {
	return propertyDataSchema.validate(data, { strip: false });
};
